import React, { createContext, useContext, useEffect, useState } from 'react'
import { bannersApi } from '../restaurant.api'

const BannersContext = createContext({
  loading: true,
  banners: [],
  refresh: () => {},
})

export const useBanners = () => useContext(BannersContext)

export const BannersProvider = ({ children }) => {
  const [loading, setLoading] = useState(true)
  const [banners, setBanners] = useState([])

  const load = async () => {
    setLoading(true)
    const { response } = await bannersApi.list()
    if (response) setBanners(response.data || [])
    setLoading(false)
  }

  useEffect(() => {
    load()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <BannersContext.Provider value={{ loading, banners, refresh: load }}>
      {children}
    </BannersContext.Provider>
  )
}
